export default __webpack_public_path__ + "static/media/helpIcon.7969e8b8.svg";